module.exports = __webpack_public_path__ + "static/media/user-mobile.1b4aacfc.svg";